import { Component, OnInit } from '@angular/core';
import { faMarker, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'html-marker',
    template: `<fa-icon [icon]="markerIcon"></fa-icon>`
})
export class HTMLMarkerComponent {
    public markerIcon: IconDefinition = faMarker;

}
